// Campus photo for /colleges/university-of-north-carolina-at-charlotte: CC BY-SA 2.0, by Ken Lund from Reno, Nevada, USA, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUniversity_of_North_Carolina_at_Charlotte%2C_Charlotte%2C_North_Carolina_(47492518832).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-north-carolina-at-charlotte/; credited under the photo.
const photo = {
    "slug": "university-of-north-carolina-at-charlotte",
    "alt": "A red brick building with white columns behind a lawn and flowering shrubs on the UNC Charlotte campus",
    "src": "/colleges/university-of-north-carolina-at-charlotte/campus-1600.webp",
    "srcSmall": "/colleges/university-of-north-carolina-at-charlotte/campus-800.webp",
    "srcMid": "/colleges/university-of-north-carolina-at-charlotte/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-north-carolina-at-charlotte/og.jpg",
    "title": "University of North Carolina at Charlotte, Charlotte, North Carolina (47492518832)",
    "author": "Ken Lund from Reno, Nevada, USA",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUniversity_of_North_Carolina_at_Charlotte%2C_Charlotte%2C_North_Carolina_(47492518832).jpg",
    "read": "2026-10-01"
};

export default photo;
